export default "__VITE_ASSET__BVu3jqBc__"